import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ncoder/ui';
import { PerformanceMetric } from '../../atoms/testing/PerformanceMetric';

interface PerformanceMetricsProps {
  successRate: string;
  avgResponseTime: string;
  userSatisfaction: string;
  testsRun: string;
}

export const PerformanceMetrics: React.FC<PerformanceMetricsProps> = ({
  successRate,
  avgResponseTime,
  userSatisfaction,
  testsRun,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Performance Metrics</CardTitle>
        <CardDescription>Overall agent performance analysis</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <PerformanceMetric 
            value={successRate} 
            label="Success Rate" 
            color="green" 
          />
          <PerformanceMetric 
            value={avgResponseTime} 
            label="Avg Response Time" 
            color="blue" 
          />
          <PerformanceMetric 
            value={userSatisfaction} 
            label="User Satisfaction" 
            color="purple" 
          />
          <PerformanceMetric 
            value={testsRun} 
            label="Tests Run" 
            color="orange" 
          />
        </div>
      </CardContent>
    </Card>
  );
};
